import React from 'react';

// Partner logos live in public/partners/ (local files — no hot-linking).
// The row is an infinite horizontal marquee inside a narrow, edge-faded
// viewport, so logos glide in from the right and out to the left. Pauses on hover.
const PARTNERS = [
    { name: 'Zarposh Collection', logo: '/partners/zarposh.svg', className: 'h-9 md:h-10 w-auto' },
    { name: 'Emral', logo: 'https://emral.pk/cdn/shop/files/new-logo-emral.jpg?v=1738232674&width=135', className: 'h-9 md:h-10 w-auto' },
    { name: 'ziml', logo: '/partners/ziml.png', className: 'h-8 md:h-9 w-auto' },
    { name: 'D.W. Group', logo: '/partners/dwg-ink.png', className: 'h-8 md:h-9 w-auto' },
];

const Partners = () => {
    // Two copies back-to-back; the track slides by exactly one copy's width (-50%)
    // and loops, which reads as an endless belt.
    const track = [...PARTNERS, ...PARTNERS];

    return (
        <section id="partners" className="w-full py-20 bg-card border-t border-borderLight scroll-mt-24">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex flex-col items-center gap-12">
                    <div className="flex flex-col items-center gap-3">
                        <span className="text-textMuted font-mono uppercase tracking-label text-[10px]">Trusted By Leaders</span>
                        <h2 className="text-3xl font-bold text-ink tracking-head">Our Partners</h2>
                    </div>

                    {/* narrow viewport with soft edges */}
                    <div className="partners-viewport w-full max-w-3xl mx-auto overflow-hidden" aria-label="Partner logos">
                        <div className="partners-track flex items-center w-max">
                            {track.map((partner, i) => (
                                <div
                                    key={`${partner.name}-${i}`}
                                    title={partner.name}
                                    aria-hidden={i >= PARTNERS.length}
                                    className="group flex-none mx-3 md:mx-4 flex items-center justify-center h-20 px-8 md:px-10 rounded-2xl border border-borderLight bg-card hover:border-ink hover:shadow-hard-soft transition-all duration-300"
                                >
                                    <img
                                        src={partner.logo}
                                        alt={partner.name}
                                        loading="lazy"
                                        draggable={false}
                                        className={`${partner.className} grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300`}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Partners;
